import { render, staticRenderFns } from "./BillPayableStatusChip.vue?vue&type=template&id=1c013968&"
import script from "./BillPayableStatusChip.vue?vue&type=script&lang=js&"
export * from "./BillPayableStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports